import type { Event } from '@cocoonspace/sdk-js/types/event'
import mitt from 'mitt'

export type ExpirationEvents = {
	'expiration.start': Event
	'expiration.reset': undefined
}

export const expirationEmitter = mitt<ExpirationEvents>()
